var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{attrs:{"index":_vm.menuItem.path}},[_c('i',{class:[_vm.menuItem.icon]}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.menuItem.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }